var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "airdrop-event-win-modal",
        "dialog-class": "airdrop-event-win-modal",
        "hide-header": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        "hide-footer": "",
        centered: "",
      },
    },
    [
      _c("div", { attrs: { id: "airdrop-event-win" } }, [
        _c("img", {
          staticClass: "fireworks",
          attrs: {
            src: `${_vm.$s3}/img/common/event/airdrop/airdrop-background.webp?${_vm.$ver}`,
          },
        }),
        _c("img", {
          staticClass: "winner",
          attrs: {
            src: `${_vm.$s3}/img/${_vm.lang}/event/airdrop/win.webp?${_vm.$ver}`,
          },
        }),
        _c(
          "button",
          { staticClass: "go-to-regist", on: { click: _vm.submitWallet } },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.lang === "ko"
                    ? "지갑 주소 제출 하기"
                    : "Submit wallet address"
                ) +
                "\n    "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }